import React from "react";
import UseContext from "hooks/useContext";
import ActivityTemplate from "pages/missionTemplates/body/activity.template";
import PrerequisTemplate from "pages/missionTemplates/body/prerequis.template";
import LocationSalaryTemplate from "pages/missionTemplates/body/locationSalary.template";
import InfoTemplate from "pages/missionTemplates/body/info.template";
import ConfirmationTemplate from "pages/missionTemplates/body/confirmation.template";

const TemplateFormsCreate = () => {
    const { templatePage } = UseContext();
    const display = {
        1: <ActivityTemplate key="activity" />,
        2: <PrerequisTemplate key="prerequis" />,
        3: <LocationSalaryTemplate key="locationSalary" />,
        4: <InfoTemplate key="info" />,
        5: <ConfirmationTemplate key="confirmation" />,
    };
    return <>{display[templatePage]}</>;
};

export default TemplateFormsCreate;
